import { useMemo } from 'react';
import { API } from '@unboared/react';

import { Game } from '~/types/game';
import { VoteContext } from '~/services/freePlay/types';
import { VoteService } from '~/services/freePlay';
import { useVoteTimer } from '~/hooks/freePlay';

import styles from './VoteBanner.module.css';

export type VoteBannerProps = {
    vote: VoteContext;
    proposedGame?: Game;
    /** Override the initiator name (debug). Falls back to API.getUsername. */
    initiatorName?: string;
};

/* TODO i18n: keys screen.freePlay.voteBanner.* */
export function VoteBanner({ vote, proposedGame, initiatorName }: VoteBannerProps) {
    const secondsLeft = useVoteTimer(vote.deadline);
    const tally = useMemo(() => VoteService.tally(vote), [vote]);
    const proposedName = proposedGame?.name ?? vote.proposedGameID;

    /* Bilingual fallback to match this shared-TV banner (a phone can propose without a
       username). */
    const ANON = 'Un joueur · A player';
    let displayName = initiatorName;
    if (!displayName) {
        try {
            displayName = API.getUsername(vote.initiatorID);
        } catch {
            displayName = ANON;
        }
    }

    return (
        <div className={styles.container}>
            <span className={styles.pill}>Vote</span>
            <div className={styles.text}>
                <div>
                    <strong>{displayName || ANON}</strong> → <strong>{proposedName}</strong>
                </div>
                <div className={styles.cta}>📱 Votez sur vos téléphones · Vote on your phones</div>
            </div>
            <div className={styles.counter}>
                <div className={styles.timer}>{secondsLeft}s</div>
                <div className={styles.tally}>
                    <span>
                        ✓ <strong>{tally.yes}</strong> · ✕ {tally.no}
                    </span>
                    <span>⏳ {tally.pending}</span>
                </div>
            </div>
        </div>
    );
}
